import React from 'react';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { LiveRegion } from './live-region';

export const withLiveRegionHandler = WrappedComponent =>
  class extends React.Component {
    static displayName = `WithLiveRegion(${getDisplayName(WrappedComponent)})`;

    constructor(props) {
      super(props);

      this.state = {
        a11yMessage: '',
      };

      this.setA11yMessage = this.setA11yMessage.bind(this);
    }

    /**
     * Call this function to update live region text
     *
     * @param {string} message Text that screen readers will read
     * @returns {undefined} No return value
     */
    setA11yMessage(message) {
      this.setState({
        a11yMessage: message,
      });
    }

    render() {
      return (
        <React.Fragment>
          <WrappedComponent setA11yMessage={this.setA11yMessage} {...this.props} />
          <LiveRegion screenReaderText={this.state.a11yMessage} {...this.props} />
        </React.Fragment>
      );
    }
  };
